@if (userDetailsService.user()) {
<pui-card title="Szczegóły" class="user-details">
  <button card-action pui-button variant="secondary" (click)="userDetailsService.close()">
    <pui-icon left icon="x-close" />
  </button>
  <!-- HEADER -->
  <div class="user-details__header">
    <div class="user-details__title d-flex flex-column">
      <h2>{{ user()?.firstName }} {{ user()?.lastName }}</h2>
      <div class="subtitle d-flex">
        {{ user()?.username }}
        <pui-badge [variant]="$safeNavigationMigration(user()?.group) | groupColor">{{ user()?.group }}</pui-badge>
      </div>
    </div>
  </div>

  <!-- ACTIONS -->
  <div class="user-details__actions">
    <button pui-button variant="primary">Wyślij wiadomość</button>
    <button pui-button variant="secondary" (click)="onEdit($safeNavigationMigration(user()?.username))">
      Edytuj dane
    </button>
    <button pui-button [puiMenuTriggerFor]="menu" variant="secondary">...</button>
    <ng-template #menu>
      <pui-menu-content>
        <button pui-button variant="secondary" pui-menu-item>Połącz z podmiotem uprawnionym</button>
        <button pui-button variant="secondary" pui-menu-item
          (click)="onBlock()">@if(user()?.enabled){Zablokuj}@else{Odblokuj}</button>
        <button pui-button variant="secondary" pui-menu-item (click)="onDelete()">Usuń konto</button>
      </pui-menu-content>
    </ng-template>
  </div>

  <!-- SECTION -->
  <div class="user-details__section">
    <h3>Informacje ogólne</h3>

    <div class="info-row">
      <span class="label">Jednostka</span>
      <span class="value">{{ user()?.responsibleUnit }}</span>
    </div>

    <div class="info-row">
      <span class="label">Organizacja</span>
      <span class="value">{{ user()?.organization }}</span>
    </div>

    <div class="info-row">
      <span class="label">Rola</span>
      <span class="value">{{ user()?.role }}</span>
    </div>

    <div class="info-row">
      <span class="label">Status</span>
      <span class="value"><pui-badge [variant]="user()?.enabled ? 'success' : 'danger'">{{
          user()?.enabled ? 'Aktywny' : 'Nieaktywny'
          }}</pui-badge></span>
    </div>
  </div>

  <!-- SECTION -->
  <div class="user-details__section">
    <h3>Informacje dodatkowe</h3>

    <div class="info-row">
      <span class="label">Email</span>
      <span class="value">{{ user()?.email }}</span>
    </div>

    <div class="info-row">
      <span class="label">Telefon</span>
      <span class="value">
        @for (tel of user()?.phone; track $index) {
        {{ tel }}
        }
      </span>
    </div>

    <div class="info-row">
      <span class="label">Język</span>
      <span class="value">{{ user()?.locale }}</span>
    </div>

    <div class="info-row">
      <span class="label">Czas</span>
      <span class="value">{{ user()?.time }}</span>
    </div>

    <div class="info-row">
      <span class="label">ASM2 info</span>
      <span class="value">UTC</span>
    </div>
  </div>
</pui-card>
}